import { render, staticRenderFns } from "./Shonto.vue?vue&type=template&id=67317530&lang=html&"
import script from "./Shonto.vue?vue&type=script&lang=js&"
export * from "./Shonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports